<template>
    <div class="events">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>News & Events</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="bg">
            <img src="../assets/imgs/uploads/mobile/eventsbg.jpg" alt="" style="width: 100%;">
            <div class="tit">
                <div style="font-size: 6.4vw;font-weight: bold;display: flex;justify-content: center;width: 53.6vw;">
                    News and Events</div>
            </div>
        </div>
        <div class="center">
            <div>
                <div class="tips" v-for="item in list" :key="item.id">
                    <div>
                        <img v-lazy="item.newsImg" alt="" style="width: 84.533vw;height: 53.333vw;">
                    </div>
                    <div style="margin-top: 4.533vw;text-align: center;">
                        <div style="font-size: 5.333vw;font-weight: bold;color: #000;margin-bottom: 1.867vw;">
                            {{ item.title }}
                        </div>
                        <div style="font-weight: bold;color: #CA141D;margin-bottom: 3.733vw;">
                            {{ item.words }} · {{ item.month }} {{ item.year }}
                        </div>
                        <div style="color: #545454;margin-bottom: 5.867vw;">
                            {{ item.excerpt }}</div>
                        <button class="btn" @click="detail(item.id)">Read more</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [],
        }
    },
    mounted() {
        this.getlist()
    },
    methods: {
        getlist() {
            this.$axios
                .post("/api/mall/news/list")
                .then(res => {
                    if (res.data.code === 200) {
                        this.list = res.data.data
                    } else {
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        detail(id) {
            this.$router.push({
                path: '/eventscenter',
                query: {
                    id: id
                }
            })
        },
    }
}
</script>

<style scoped>
.events {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}
.center{
    padding: 0 29px;
}
.bg {
    position: relative;
}

.tit {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #FFF;
}

.tips {
    padding: 30px 0;
    border-bottom: 1px solid #D9D9D9;
}
.tips:last-child{
    border-bottom: none;
}
.btn {
    width: 296px;
    height: 47px;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    border-radius: 5px;
    background-color: #CA141D;
    color: #FFF;
    border: none;
}
</style>